import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Button, Card } from "reactstrap";
import {
  GetRequestSuggestions,
  LinkRequestToWine,
} from "network/wineDataSetAPI";
import { ErrorToaster, successToaster } from "components/common/toast";
import handleError from "utils/handleError";

// Strumenti dell'operatore su una richiesta: vini simili gia' nel dataset
// ("e' questo vino") e proposta dell'AI per i campi mancanti.
const RequestOperatorPanel = ({ requestId, onLinked }) => {
  const { t } = useTranslation("wine");
  const [suggestions, setSuggestions] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    GetRequestSuggestions(requestId)
      .then((res) => active && setSuggestions(res?.data?.suggestions || []))
      .catch(() => active && setSuggestions([]));
    return () => {
      active = false;
    };
  }, [requestId]);

  const link = async (wine) => {
    setBusy(true);
    try {
      const res = await LinkRequestToWine(requestId, wine.uuid);
      successToaster(res?.message || t("operator.linked"));
      onLinked();
    } catch (error) {
      ErrorToaster(handleError(error?.status_code, error?.message));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="p-3 mb-4">
      <h4 className="mb-3">{t("operator.title")}</h4>
      {suggestions === null ? (
        <p className="mb-2">{t("operator.searching")}</p>
      ) : suggestions.length === 0 ? (
        <p className="mb-2">{t("operator.none")}</p>
      ) : (
        suggestions.map((wine) => (
          <div
            key={wine.uuid}
            className="d-flex flex-wrap justify-content-between align-items-center border-bottom py-2"
          >
            <div>
              <strong>{wine.name}</strong>
              <div className="text-muted">
                {[wine.winery, wine.vintage, wine.ean && `EAN ${wine.ean}`]
                  .filter(Boolean)
                  .join(" · ")}
                {" — "}{t("operator.similarity", { percent: Math.round(wine.score * 100) })}
                {wine.note ? ` (${wine.note})` : ""}
              </div>
            </div>
            <Button
              size="sm"
              color="success"
              disabled={busy}
              onClick={() => link(wine)}
            >
              {t("operator.isThisWine")}
            </Button>
          </div>
        ))
      )}
    </Card>
  );
};

export default RequestOperatorPanel;
